<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2175_6934" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20">
      <rect x="0.772461" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2175_6934)">
      <path
        d="M16.2725 12.75V10.75H5.27246V12.75H16.2725ZM16.2725 9.25V7.25H5.27246V9.25H16.2725ZM16.2725 5.75V4.5H5.27246V5.75H16.2725ZM5.27246 17C4.86968 17 4.51899 16.8507 4.22038 16.5521C3.92177 16.2535 3.77246 15.9028 3.77246 15.5V4.5C3.77246 4.0875 3.92177 3.73438 4.22038 3.44063C4.51899 3.14688 4.86968 3 5.27246 3H16.2725C16.685 3 17.0381 3.14688 17.3318 3.44063C17.6256 3.73438 17.7725 4.0875 17.7725 4.5V15.5C17.7725 15.9028 17.6256 16.2535 17.3318 16.5521C17.0381 16.8507 16.685 17 16.2725 17H5.27246ZM16.2725 15.5V14.25H5.27246V15.5H16.2725Z"
        :fill="fillColor" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fillColor: {
      get() {
        if (this.isActive) return "#49545C";

        return "rgba(73, 84, 92, 0.30)";
      },
      set(color) {
        return color;
      }
    }
  }
}
</script>
